import { configureStore } from '@reduxjs/toolkit';
import textChunkerReducer from './Tools/PostSplitter/textChunkerSlice';
import sentimentSlice from './Tools/Sentiment/SentimentSlice';
import hashtagsSlice from './Tools/Hashtags/HashtagsSlice'
import emojisSlice from './Tools/Emojis/EmojisSlice';
import aiTextDetectorSlice from './Tools/DetectAI/AITextDetectorSlice';
import readabilitySlice from './Tools/ReadabilityChecker/ReadabilitySlice';
import textSummarizationSlice from './Tools/Summarization/TextSummarizationSlice';
import keywordExtractionSlice from './Tools/KeywordExtraction/KeywordExtractionSlice';
import semanticSimilaritySlice from './Tools/SemanticSimilarity/SemanticSimilaritySlice';

export const store = configureStore({
  reducer: {
    textChunker: textChunkerReducer,
    textSentiment: sentimentSlice,
    hashtagsAnalyzer: hashtagsSlice,
    emojisSlice: emojisSlice,
    aiTextDetectorSlice: aiTextDetectorSlice,
    readabilitySlice: readabilitySlice,
    textSummarizationSlice: textSummarizationSlice,
    keywordExtraction: keywordExtractionSlice,
    semanticSimilarity: semanticSimilaritySlice,
  },
});
